import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, QueryList, ViewContainerRef, ViewRef } from '@angular/core';
import { InputConverter, JSONConverter } from '../../../inputConverter';
import { DocumentService } from '../../../services/document.service';
import { BaseComponent } from '../../base.component';
import { DocSourceItemComponent } from '../doc-source-item/doc-source-item.component';
var DocSourceComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocSourceComponent, _super);
    function DocSourceComponent(_vcr, documentService, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this.documentService = documentService;
        _this.cdr = cdr;
        _this._currentFeature = null;
        _this._currentTable = null;
        _this.loading = true;
        _this.docSourcesUpdated = new EventEmitter();
        _this.currentIndex = null;
        _this.documents = [];
        _this.imgVideoDocs = [];
        _this.registerEvent('docSourcesUpdated', _this.docSourcesUpdated);
        return _this;
    }
    Object.defineProperty(DocSourceComponent.prototype, "currentFeature", {
        get: function () {
            return this._currentFeature;
        },
        set: function (value) {
            this._currentFeature = JSONConverter(value);
            this.updateDocSources();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceComponent.prototype, "currentTable", {
        get: function () {
            return this._currentTable;
        },
        set: function (value) {
            this._currentTable = JSONConverter(value);
            this.updateDocSources();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocSourceComponent.prototype, "docSources", {
        get: function () {
            return this._docSources;
        },
        set: function (value) {
            this._docSources = value;
            this.loading = false;
            if (this.cdr && !this.cdr.destroyed) {
                this.cdr.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    DocSourceComponent.prototype.buildDocumentGroups = function (tree) {
        var e_1, _a;
        var groups = {};
        try {
            for (var _b = tslib_1.__values(tree.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var node = _c.value;
                var key = node.data.record.documentType;
                if (!groups[key]) {
                    groups[key] = [];
                }
                groups[key].push(node);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return Object.entries(groups);
    };
    DocSourceComponent.prototype.updateDocSources = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sources, attributes, layer, layerId, _a, docSources, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.loading = true;
                        this.clearDocSources();
                        if (!this.currentFeature) return [3 /*break*/, 5];
                        if (!(this.currentFeature.sourceLayer && this.currentFeature.sourceLayer.source && this.currentFeature.sourceLayer.source.dataSource)) return [3 /*break*/, 4];
                        layerId = this.currentFeature.sourceLayer.source.dataSource.workspaceId;
                        if (!layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.documentService.getLayerDocSources(layerId)];
                    case 1:
                        _a = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = null;
                        _c.label = 3;
                    case 3:
                        sources = _a;
                        _c.label = 4;
                    case 4:
                        attributes = this.currentFeature.attributes;
                        layer = this.currentFeature.layer;
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(this.currentTable && this.currentTable.tableId)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.documentService.getTableDocSources(this.currentTable.tableId)];
                    case 6:
                        sources = _c.sent();
                        attributes = this.currentTable.attributes;
                        _c.label = 7;
                    case 7:
                        docSources = sources && sources.length ? sources[0].docSources : [];
                        _b = this;
                        return [4 /*yield*/, this.documentService.getDocuments({ attributes: attributes }, docSources, layer)];
                    case 8:
                        _b.documents = _c.sent();
                        this.imgVideoDocs = this.documents.filter(function (d) { return _this.documentService.isImage(d) || _this.documentService.isVideo(d); });
                        if (this.documents.length) {
                            this.documents.forEach(function (document, index) {
                                var columnName = "DOCUMENT_URL_" + index.toString();
                                // If we revisit a previously visited layer in the identify dialog, the document sources will be
                                // unloaded, but the previously added attributes will remain. Don't add them again.
                                if (!attributes.some(function (a) { return a.columnName === columnName; })) {
                                    attributes.push({
                                        columnName: columnName,
                                        displayName: columnName,
                                        value: document.source === 'ECS' ? document.url + "&download=1" : document.url,
                                        displayText: document.displayText,
                                        type: document.source === 'ECS' ? 'download-url' : 'open-url'
                                    });
                                }
                            });
                            this.currentIndex = 0;
                        }
                        this.currentRecord = { attributes: attributes };
                        if (docSources) {
                            this.docSources = docSources;
                            this.docSourcesUpdated.emit(this.docSources);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(DocSourceComponent.prototype, "currentDocument", {
        get: function () {
            if (this.currentIndex !== null && this.imgVideoDocs.length) {
                return this.imgVideoDocs[this.currentIndex];
            }
        },
        enumerable: true,
        configurable: true
    });
    DocSourceComponent.prototype.moveForward = function () {
        this.currentIndex++;
    };
    DocSourceComponent.prototype.moveBackward = function () {
        this.currentIndex--;
    };
    DocSourceComponent.prototype.clearDocSources = function () {
        this.docSources = [];
        this.documents = [];
        this.imgVideoDocs = [];
        this.currentIndex = null;
        this.docSourcesUpdated.emit(this.docSources);
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], DocSourceComponent.prototype, "currentFeature", null);
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [Object])
    ], DocSourceComponent.prototype, "currentTable", null);
    return DocSourceComponent;
}(BaseComponent));
export { DocSourceComponent };
